import { render, staticRenderFns } from "./BaseCombobox.vue?vue&type=template&id=4862863f&scoped=true"
import script from "./BaseCombobox.ts?vue&type=script&lang=ts&external"
export * from "./BaseCombobox.ts?vue&type=script&lang=ts&external"
import style0 from "./BaseCombobox.scss?vue&type=style&index=0&id=4862863f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862863f",
  null
  
)

export default component.exports